var main = require('org_km/search');

main.baseFiles.plpStickyFilter = require('org_km/product/plpStickyFilter');

module.exports = main;
